<template>
  <div class="homeworkContent" :v-loading="loading">
    <div class="homeworkContent_item">
      <span class="homeworkContent_title">作业标题</span>
      <span class="homeworkContent_left">{{homeworkForm.content}}</span>
    </div>
    <!-- <div class="homeworkContent_item">
      <span class="homeworkContent_title">截止时间</span>
      <span class="homeworkContent_left">{{homeworkForm.createTime}}</span>
    </div> -->
    <div v-if="homeworkForm.imgList!=null">
    <div class="homeworkContent_item flex-starts" style="align-items:start" v-if="homeworkForm.imgList.length > 0">
      <div class="homeworkContent_title">图片</div>
      <div class="homeworkContent_box_img">
        <img v-for="item in homeworkForm.imgList" :key="item.id" :src="item.url" class="homeworkContent_img">
      </div>
    </div>
    </div>
    <div v-if="homeworkForm.questionList!=null">
    <div class="flex-starts homeworkContent_item" style="align-items:start" v-if="homeworkForm.questionList.length > 0">
      <div class="homeworkContent_title">试题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
      <el-table :data="homeworkForm.questionList" border class="homeworkContent_left" row-key="id">
        <el-table-column
          label="排序"
          type="index"
          width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="questionTypeName"
          label="题型"
          width="100"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column prop="title" label="题干" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-html="scope.row.title">大题</span>
          </template>
        </el-table-column>
        <el-table-column prop="answer" label="答案" width="80" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      homeworkForm: {
        imgList: [],
        questionList: []
      },
    };
  },
  props: {
    homeworkId: null,
  },
  computed: {},
  created() {},
  methods: {
    getHomework() {
      this.loading = true;
      this.api.homework.getHomework({ id: this.homeworkId }).then((result) => {
        if (result.success) {
          this.loading = false;
          this.homeworkForm = result.data;
        } else {
          this.loading = false;
          this.$message.error(result.message);
        }
      });
    },
  },
  mounted() {
    this.getHomework();
  },
  watch: {},
};
</script>

<style lang="less" rel="stylesheet/less">
.homeworkContent {
  height: calc(100vh - 80px);
  overflow-y: auto;
  padding: 0 20px 20px 20px;
}
.homeworkContent_item{
  margin-bottom: 20px;
}
.homeworkContent_title{
  color: #a2aabc;
}
.homeworkContent_left{
  margin-left: 10px;
  overflow: hidden;
  word-break: break-all;
}
.homeworkContent_box_img{
  display: flex;
  flex-wrap: wrap;
  margin-left: 40px;
}
.homeworkContent_img{
  width: 80px;
  height: 80px;
  margin-right: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/homeworkContent.vue